import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CertificatesList } from "../Data/CertificatesList";

type CertificatesProps = { isSmallScreen: boolean };

function Certificates(_props: CertificatesProps) {
  const theme = useTheme();

  return (
    <Box sx={{ py: 6 }}>
      <Typography variant="h1" fontWeight={700}>
        <span style={{ color: theme.palette.secondary.main }}>Certificates</span>
      </Typography>
      <Grid container spacing={3}>
        {CertificatesList.map((cert) => (
          <Grid item xs={12} sm={6} md={4} key={cert.id}>
            <Card
              sx={{
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                transition: "transform 0.2s",
                "&:hover": { transform: "scale(1.02)" },
              }}
            >
              <CardMedia
                component="img"
                image={cert.image}
                alt={cert.name}
                sx={{ objectFit: "contain", backgroundColor: "#fff" }}
              />
              <CardContent
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h3" sx={{ py: 0, mb: 0 }}>
                    {cert.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: theme.palette.text.secondary }}
                  >
                    {cert.issuer}
                  </Typography>
                </Box>
                <Button
                  size="small"
                  variant="outlined"
                  href={cert.verifyUrl}
                  target="_blank"
                  sx={{
                    borderColor: theme.palette.secondary.main,
                    textTransform: "none",
                  }}
                >
                  Verify
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Certificates;
